module.exports = __webpack_public_path__ + "static/img/Bachelor_010287.58db133.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010287.jpg
// module id = 139
// module chunks = 0